import { render, staticRenderFns } from "./RequestAccountDeleteDialog.vue?vue&type=template&id=b5d7ed78"
import script from "./RequestAccountDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./RequestAccountDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports